import { render, staticRenderFns } from "./TeamSelect.vue?vue&type=template&id=1292135a"
import script from "./TeamSelect.vue?vue&type=script&lang=js"
export * from "./TeamSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports